import '.bn{position:relative;}.ssr-plugin'
import '.f8{appearance:none;}.ssr-plugin'
import '.bi{flex-shrink:0;}.ssr-plugin'
import '.de{width:1.5rem;}.ssr-plugin'
import '.df{height:1.5rem;}.ssr-plugin'
import '.hn{border-radius:0.4375rem;}.ssr-plugin'
import '.ho{border:2px solid var(--gray-200);}.ssr-plugin'
import '.cs{background:var(--shades-white);}.ssr-plugin'
import '.hp{font-size:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.ay{font-style:normal;}.ssr-plugin'
import '.ax{font-weight:400;}.ssr-plugin'
import '.bw{user-select:none;}.ssr-plugin'
import '.aj{gap:0.5rem;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { useId } from 'react'
import { Icon } from '../icon/Icon'
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons'
import { Tooltip } from '../tooltip/Tooltip'

export type CheckboxProps = {
  selected: boolean
  label?: string
  labelPosition?: 'left' | 'right'
  labelSize?: 'medium' | 'small'
  labelStyle?: Style
  inputStyle?: Style
  disabled?: boolean
  onClick: () => void
  tooltipText?: string
}

export const Checkbox = ({
  selected,
  label,
  labelPosition = 'right',
  labelSize = 'medium',
  labelStyle,
  inputStyle,
  disabled = false,
  tooltipText,
  onClick,
}: CheckboxProps) => {
  const id = useId()
  const handler = () => {
    if (!disabled) {
      onClick()
    }
  }

  const input = (
    <styled.input className="bn f8 bi de df hn ho cs hp"
      key="checkbox-input"
      id={id}
      checked={selected}
      type="checkbox"
      disabled={disabled}
      onChange={handler}
      style={{
        cursor: disabled ? 'not-allowed' : 'pointer',
        '&:hover': {
          border: '2px solid var(--gray-300)',
        },
        '&:checked': {
          background: 'var(--primary-blue)',
          border: '2px solid var(--primary-blue)',
        },
        '&:disabled': {
          background: 'var(--gray-100)',
          border: '2px solid var(--gray-200)',
        },
        '&:checked:disabled': {
          background: 'var(--shades-blue-100)',
          border: '2px solid var(--shades-blue-100)',
        },
        '&:checked::after': {
          content: `url("data:image/svg+xml,%3Csvg width='16' height='12' viewBox='0 0 16 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.6875 1.3125C15.0938 1.6875 15.0938 2.34375 14.6875 2.71875L6.6875 10.7188C6.3125 11.125 5.65625 11.125 5.28125 10.7188L1.28125 6.71875C0.875 6.34375 0.875 5.6875 1.28125 5.3125C1.65625 4.90625 2.3125 4.90625 2.6875 5.3125L6 8.59375L13.2812 1.3125C13.6562 0.90625 14.3125 0.90625 14.6875 1.3125Z' fill='white'/%3E%3C/svg%3E%0A");`,
          position: 'absolute',
          top: '0.25rem',
          left: '0.125rem',
          width: '1rem',
          height: '1rem',
          opacity: 1,
          fontSize: 0,
        },
        ...inputStyle,
      }}
    />
  )

  const labelComponent = <styled.div key="checkbox-label">{label}</styled.div>
  const components = !label
    ? input
    : labelPosition === 'right'
      ? [input, labelComponent]
      : [labelComponent, input]

  return (
    <styled.label className="a c ay ax bw"
      htmlFor={id}
      style={{
        fontSize: labelSize === 'medium' ? '1.5rem' : '1.125rem',
        cursor: disabled ? 'not-allowed' : 'pointer',
        ...labelStyle,
      }}
    >
      <div className="a c aj"
      >
        {components}
      </div>
      {tooltipText && (
        <styled.span
          onClick={(e: React.MouseEvent) => {
            e.preventDefault()
            e.stopPropagation()
          }}
        >
          <Tooltip content={tooltipText}>
            <Icon
              icon={faCircleInfo}
              style={{
                color: 'var(--shades-blue-200)',
                '&:hover': { color: 'var(--primary-blue)' },
                '&:focus-visible': { color: 'var(--primary-blue)' },
              }}
              size="small"
            />
          </Tooltip>
        </styled.span>
      )}
    </styled.label>
  )
}
